import { css } from "styled-components";
export var getFocusOutline = function getFocusOutline(theme, hasNotOutlineOffset) {
  return css(["outline:", " auto 1px;outline-offset:", ";"], theme.colors.backgroundBlack.color, hasNotOutlineOffset ? "-2px" : "2px");
};
export default getFocusOutline;